// src/components/blog/BlogTags.jsx

import React, { memo } from 'react';

const BlogTags = memo(({ tags, onTagClick, activeTag, isDark, maxTags = 12 }) => {
  // Debug: Check what tags are being received
  console.log('🔍 BlogTags received tags:', tags);
  console.log('🔍 BlogTags received activeTag:', activeTag);
  
  // Safely check if tags exist and is an array
  if (!tags || !Array.isArray(tags) || tags.length === 0) {
    console.warn('⚠️ BlogTags: No tags available to display');
    return null;
  }

  // Filter out tags with 0 count if you want
  const visibleTags = tags.filter(tag => tag.count > 0);

  if (visibleTags.length === 0) {
    return null;
  }

  return (
    <div className={`p-6 rounded-xl ${isDark ? 'bg-white/5 border border-white/10' : 'bg-white border border-gray-200'}`}>
      <h3 className={`text-lg font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
        Popular Tags
      </h3>
      <div className="flex flex-wrap gap-2">
        {visibleTags.slice(0, maxTags).map((tag) => {
          // Use slug for matching, name for display
          const tagSlug = tag.slug || tag.id;
          const tagName = tag.name || tagSlug;
          
          return (
            <button
              key={tagSlug || tag.id}
              onClick={() => onTagClick(tagSlug)}  // Pass slug, not name
              className={`px-3 py-1 rounded-full text-sm transition-all ${
                activeTag === tagSlug  // Highlight active tag
                  ? 'bg-gradient-to-r from-blue-700 to-blue-600 text-white shadow-md'
                  : isDark 
                    ? 'bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white' 
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-900'
              }`}
              aria-label={`Search by tag ${tagName}`}
            >
              #{tagName}
              {tag.count > 0 && (
                <span className={`ml-1.5 text-xs ${
                  activeTag === tagSlug 
                    ? 'text-white/80' 
                    : isDark 
                      ? 'text-gray-500' 
                      : 'text-gray-400'
                  }`}>
                  ({tag.count})
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
});

BlogTags.displayName = 'BlogTags';

export default BlogTags;